import { render, staticRenderFns } from "./ButtonAddFile2.vue?vue&type=template&id=39fb6a3a"
import script from "./ButtonAddFile2.vue?vue&type=script&lang=js"
export * from "./ButtonAddFile2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports